module.exports = __webpack_public_path__ + "img/search_button_add_up.51e1b637.png";